import styled from '@emotion/styled'

import media from '../../../styles/media'

const S = {}

S.FooterAvailability = styled.p`
  text-align: center;
  font-size: 0.875rem;
  margin-top: 0;
  margin-bottom: 2.5rem;

  ${media.md`
    margin-bottom: 2rem;
  `};
`

export default S
